import BaseStore from 'core/stores/BaseStore';
import { ProductActivityService } from 'common/data';
import { action } from 'mobx';

class ProductActivityStore extends BaseStore {
	constructor(rootStore) {
		super(new ProductActivityService(rootStore.app.baasic.apiClient));
	}
}

export default ProductActivityStore;



// WEBPACK FOOTER //
// ./src/modules/product-activity/stores/ProductActivityStore.js